import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { pageEntityAtom } from "@ryde/shared";

export const usePageTitle = () => {
  const { t } = useTranslation();
  const entity = useRecoilValue(pageEntityAtom);

  const pageTitleTranslated = useMemo(() => {
    if (entity === "unknown") {
      return "RYDE PROGRAM";
    }

    return t(`${entity}.plural`);
  }, [entity, t]);

  return { pageTitleTranslated };
};
